import { Keyboard, KeyboardResize } from '@capacitor/keyboard'
import { useEffect } from 'react'

export function useNativeKeyboardResize() {
  useEffect(() => {
    const root = document.documentElement
    let disposed = false

    void Keyboard.setResizeMode({ mode: KeyboardResize.Native }).catch(() => undefined)
    void Keyboard.setScroll({ isDisabled: false }).catch(() => undefined)

    const handles: Array<{ remove: () => Promise<void> }> = []
    const keepHandle = (promise: Promise<{ remove: () => Promise<void> }>) => {
      void promise.then((handle) => {
        if (disposed) void handle.remove()
        else handles.push(handle)
      }).catch(() => undefined)
    }
    keepHandle(Keyboard.addListener('keyboardWillShow', () => {
      root.classList.add('keyboard-open')
    }))
    keepHandle(Keyboard.addListener('keyboardDidShow', () => {
      root.classList.add('keyboard-open')
    }))
    keepHandle(Keyboard.addListener('keyboardWillHide', () => {
      root.classList.remove('keyboard-open')
    }))
    keepHandle(Keyboard.addListener('keyboardDidHide', () => {
      root.classList.remove('keyboard-open')
    }))

    return () => {
      disposed = true
      for (const handle of handles) void handle.remove()
      root.classList.remove('keyboard-open')
    }
  }, [])
}
